import { combineReducers } from 'redux';
import { fetchLastJourney } from '../../sagas/dashboard/actions';
import { logoutButtonClick } from '../../components/Auth/actions';
import reports from './reports';
import filteredReports from './filteredReports';

const lastJourney = (state = null, action) => {
  if (action.type === fetchLastJourney.done.type) {
    return action.payload.result || state;
  }

  if (action.type === logoutButtonClick.type) {
    return null;
  }

  return state;
};

export default combineReducers({
  reports,
  filteredReports,
  lastJourney,
});



// WEBPACK FOOTER //
// ./src/reducers/dashboard/index.js